import {Component} from "@angular/core";
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'data-classification-tabs',
	templateUrl: './data-classification-tabs.component.html',
})
export class DataClassificationTabs extends TabsPageContainer {
}
